<template>
  <div class="control_bar top">
    <div class="search flex">
      <div class="flex search_area">
        <input
          type="text"
          class="search_field"
          placeholder="タイトル/法人名/テナントID/テナント名"
          v-model="inputValue"
          @focusin="$emit('focusin')"
        />
        <div class="flex">
          <div class="flex">
            <div class="start_date_label">{{ startLabel }}</div>
            <datepicker
              placeholder="Select Date"
              :config="start_config"
              :locale="ja"
              id="start"
              value=""
              @on-change="setStartDateTime"
              class="start_datepicker start_date_time"
            >
            </datepicker>
          </div>
          <span style="margin: 10px">～</span>
          <div class="flex">
            <div class="end_date_label">{{ endLabel }}</div>
            <datepicker
              placeholder="Select Date"
              :config="end_config"
              :locale="ja"
              id="end"
              value=""
              @on-change="setEndDateTime"
              class="end_datepicker end_date_time"
            >
            </datepicker>
          </div>
        </div>
      </div>

      <input
        type="button"
        :value="searchButton"
        class="search_button"
        @click="findAction"
      />
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import falseModalWindow from '../../../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'
import datepicker from 'vue-flatpickr-component'
import japanese from 'flatpickr/dist/l10n/ja.js'

export default {
  data() {
    return {
      selectedTenantId: '',
      showFalseModal: false,
      falseWord: '',
      inputValue: '',
      searchButton: '検索',
      allLabel: 'すべて',
      startLabel: '開始',
      endLabel: '終了',
      showloadingModal: false,
      ja: japanese,
      start_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date().setDate(new Date().getDate() - 7),
        minuteIncrement: 1,
        maxDate: '9999'
      },
      end_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date(),
        minuteIncrement: 1,
        maxDate: '9999'
      }
    }
  },
  computed: {},
  components: {
    datepicker,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showFalseModal = false
    },
    findAction(event) {
      this.$emit('input-event', 0, this.inputValue)
    },
    setStartDateTime(e) {
      let startDate = null
      if (e.length !== 0) {
        startDate = new Date(e)
        startDate.setSeconds(0)
      }
      this.$store.dispatch('mailHistory/setSearchStartDateTime', startDate)
      this.customFormatter(e)
    },
    setEndDateTime(e) {
      let endDate = null
      if (e.length !== 0) {
        endDate = new Date(e)
        endDate.setSeconds(59)
      }
      this.$store.dispatch('mailHistory/setSearchEndDateTime', endDate)
      this.customFormatter(e)
    },
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hours = date.getHours()
      var minutes = date.getMinutes()
      return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes
    }
  }
}
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.control_bar {
  background-color: #bbffff;
}
.search {
  width: 100%;
  height: 55px;
  margin: auto 0;
  justify-content: space-between;
}
.search_area {
  width: 70%;
}
.search_button {
  background-color: #5366ce;
  margin: 0 30px 0px 8px;
}
.start_datepicker,
.end_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
  width: calc(100% - 30px);
}

.start_date_time {
  margin-bottom: 0px;
}

.start_date_label {
  white-space: nowrap;
  margin: 0px 3px 0px 20px;
}

.end_date_label {
  white-space: nowrap;
  margin: 0px 3px 0px 0px;
}

.search_field {
  width: 30%;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/mailHistory/controlbar.vue